import React from "react";
import { SectionWrapper } from "../../../styles";
import styled from "@emotion/styled"; 

import { Container } from "@mui/material";

import { keyframes } from "@emotion/react";
const fadeinT = keyframes`
    0% {
      opacity: 0;
      top: 20vh;
    }
    
    50% {
      opacity: 1;
      top: 5vh;
    }
    100% {
      opacity: 0;
      top: 5vh;
    }
`;

const Animate = styled.a`
  cursor: pointer;
  animation: ${fadeinT} 1.8s ease-in-out forwards infinite;
`;
const Heading = styled.div`
  color: #000000;
  display: inline-block;
  font: 150px "twocent-bold-italic";
  text-align: center;
  /* display: flex;
  align-items: center; */
  /* margin-top: 4%; */
  letter-spacing: 29px;
  margin-top: ${(props) => (props.m ? props.m : "")};
  @media (max-width: 899px) {
    font-size: 100px;
    letter-spacing: 20px;
  }
  @media (max-width: 599px) {
    margin-top: 13%;
    font-size: 90px;
    letter-spacing: 0px;
  }
  @media (max-width: 400px) {
    margin-top: 13%;
    font-size: 70px;
    letter-spacing: 0px;
  }
`;
const Text1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ScrollButton = styled.div`
  text-align: center;
  font-size: 40px;
  margin-top: 80px;
  margin-bottom: 10px;
  color: #000;
  font-weight: 600;
  font-family: "two-cent-Bold";
`;
const Text = styled.div`
  position: absolute;
  bottom: 25px;
  left: 0;
  right: 0;
  text-align: center;
`;
const ArrowImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 35px;
`;

const index = () => {
  return (
    <div>
      <SectionWrapper mh900px="100vh" bgColor="#F7EB33">
        <Container maxWidth="xl">
          <Text1>
            <Heading>
              First
              <br /> Meme Blockchain*
            </Heading>
          </Text1>
          <Text>
            <Animate href="#explore">
              <ScrollButton>Explore</ScrollButton>
              <ArrowImage src="/images/arrowdown.png" />
            </Animate>
          </Text>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
